module.exports = __webpack_public_path__ + "static/media/6.c3330c54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/6.jpg
// module id = 101
// module chunks = 0